<template>
	<div>
		<input type="checkbox" id="check" />
		<!--header area start-->
		<header>
			<label for="check">
				<i 
				class="fas fa-bars" 
				id="sidebar_btn"
				data-qa="hamburgerMenuButton"></i>
			</label>
			<div class="left_area">
				<h3>expar</h3>
			</div>
			<!-- <div class="right_area" v-if="daysRemaining > 0 && !isSubscriptionDone">
				<a class="trial_btn">{{ $t('trial') }}: {{daysRemaining}} {{ $tc('daysLeft', 3) }}</a>
				</div>

				<div class="right_area" v-if="daysRemaining <= 0 && !isSubscriptionDone">
				<a class="trial_btn" @click="$bvModal.show('subscription-modal')">{{ $t('subscribe') }}</a>
				</div> -->
			<!-- Checkout at unit store is disabled!!! -->
			<div class="right_area">
				<NotificationBell v-if="notifications" :notifications="notifications" />
				<ProfileDropdown />
			</div>
		</header>
		<!--header area end-->
		<!--mobile navigation bar start-->
		<div class="mobile_nav">
		<!-- <router-link :to="{ name: 'dashboard' }"> -->
			<div class="nav_bar">
				<img
				v-if="!imageUrl"
				src="../assets/static/images/clientLogoW_200x80.png"
				class="mobile_profile_image"
				alt=""
				/>
				<img v-else :src="`${imageUrl}`" class="mobile_profile_image" alt="" />
				<i class="fa fa-bars nav_btn" @click="isActive = !isActive"></i>
			</div>
			<!-- </router-link> -->
			<transition name="fade" mode="out-in">
				<div
					class="mobile_nav_items"
					v-bind:class="{ active: isActive }"
					@click="isActive = !isActive">

					<router-link
					:to="'/' + 'dashboard/' + $i18n.locale"
					:class="activeTab === 'dashboard' ? 'sidebar_active' : 'sidebar_nonactive'"
					@click.native="activeTab = 'dashboard'"
					:onclick="topFunction()">
						<font-awesome-icon icon="tachometer-alt" />
						<span>{{$t('dashboard')}}</span>
					</router-link>

					<router-link
					:to="'/' + 'dashboard/profile/' + $i18n.locale"
					:class="activeTab === 'profile' ? 'sidebar_active' : 'sidebar_nonactive'"
					@click.native="activeTab = 'profile'"
					:onclick="topFunction()">
						<font-awesome-icon icon="address-card" />
						<span>{{$t('profile')}}</span>
					</router-link>

					<router-link
					:to="'/' + 'dashboard/team/' + $i18n.locale"
					:class="activeTab === 'team' ? 'sidebar_active' : 'sidebar_nonactive'"
					@click.native="activeTab = 'team'"
					:onclick="topFunction()">
						<font-awesome-icon icon="users" />
						<span>{{$t('team')}}</span>
					</router-link>
					
					<router-link
					:to="'/' + 'units/' + $i18n.locale"
					:class="activeTab === 'units' ? 'sidebar_active' : 'sidebar_nonactive'"
					@click.native="activeTab = 'units'"
					:onclick="topFunction()">
						<font-awesome-icon icon="map-marked-alt" />
						<span>{{$tc('unit', 3)}}</span>
					</router-link>
					<!-- <router-link :to="'/' + 'productCategories/' + $i18n.locale"><font-awesome-icon icon="clipboard-list" /><span @click="isActive = !isActive">{{ $tc('category', 2) }}</span></router-link>
					<router-link :to="'/' + 'suppliers/' + $i18n.locale"><font-awesome-icon icon="truck" /><span @click="isActive = !isActive">{{ $tc('supplier', 2) }}</span ></router-link> -->
					<router-link
					:to="'/' + 'products/' + $i18n.locale"
					:class="activeTab === 'products' ? 'sidebar_active' : 'sidebar_nonactive'"
					@click.native="activeTab = 'products'"
					:onclick="topFunction()">
						<font-awesome-icon icon="tag" />
						<span>{{$t('prodCatalogue')}}</span>
					</router-link>
					
					<router-link
					:to="'/' + 'dashboard/inventory/' + $i18n.locale"
					:class="activeTab === 'inventory' ? 'sidebar_active' : 'sidebar_nonactive'"
					@click.native="activeTab = 'inventory'"
					:onclick="topFunction()">
						<font-awesome-icon icon="dolly" />
						<span>{{$t('inventory')}}</span>
					</router-link>
					
					<router-link
					:to="'/' + 'dashboard/payments/' + $i18n.locale"
					:class="activeTab === 'payments' ? 'sidebar_active' : 'sidebar_nonactive'"
					@click.native="activeTab = 'payments'"
					:onclick="topFunction()">
						<font-awesome-icon icon="credit-card" />
						<span>{{$tc('payment', 3)}}</span>
					</router-link>
					
					<router-link
					:to="'/' + 'dashboard/deliveries/' + $i18n.locale"
					:class="activeTab === 'deliveries' ? 'sidebar_active' : 'sidebar_nonactive'"
					@click.native="activeTab = 'deliveries'"
					:onclick="topFunction()">
						<font-awesome-icon icon="box-open" />
						<span>{{$tc('delivery', 2)}}</span>
					</router-link>
					
					<!-- <router-link
					:to="'/' + 'tax/verification/' + $i18n.locale"
					:class="activeTab === 'tax' ? 'sidebar_active' : 'sidebar_nonactive'"
					@click.native="activeTab = 'tax'"
					:onclick="topFunction()">
						<font-awesome-icon icon="receipt" />
						<span>{{$t('taxVerification')}}</span>
					</router-link> -->

					<router-link
					:to="'/' + 'dashboard/marketplace/' + $i18n.locale"
					:class="activeTab === 'marketplace' ? 'sidebar_active' : 'sidebar_nonactive'"
					@click.native="activeTab = 'marketplace'"
					:onclick="topFunction()">
						<font-awesome-icon icon="store" />
						<span>{{$t('marketplace')}}</span>
					</router-link>

					<!-- <b-button
					><font-awesome-icon class="icon" icon="question" />
					{{ $t('help') }}</b-button
					> -->
				</div>
			</transition>
		</div>
		<!--mobile navigation bar end-->

		<!--sidebar start-->
		<div class="sidebar">
			<router-link :to="{ name: 'dashboard' }" class="no-hover">
				<div class="profile_info">
				<img
					v-if="!imageUrl"
					src="../assets/static/images/clientLogoW_200x80.png"
					class="profile_image"
					alt=""
				/>
				<img v-else :src="`${imageUrl}`" class="profile_image" alt="" />
				<h4>{{ client.client.name }}</h4>
				</div>
			</router-link>
			<router-link
				:to="'/' + 'dashboard/' + $i18n.locale"
				:class="activeTab === 'dashboard' ? 'sidebar_active' : 'sidebar_nonactive'"
				@click.native="activeTab = 'dashboard'"
				data-qa="dashboardButton">
				<div>
					<font-awesome-icon
						:title="$t('dashboard')"
						class="icon"
						icon="tachometer-alt"/>
					<span>{{ $t('dashboard') }}</span>
				</div>
			</router-link>
			<router-link
				:to="'/' + 'dashboard/profile/' + $i18n.locale"
				:class="activeTab === 'profile' ? 'sidebar_active' : 'sidebar_nonactive'"
				@click.native="activeTab = 'profile'"
				data-qa="profileButton">
				<div>
					<font-awesome-icon
						:title="$t('profile')"
						class="icon"
						icon="address-card"/>
						<span>{{ $t('profile') }}</span>
				</div>
			</router-link>
			<router-link
				:to="'/' + 'dashboard/team/' + $i18n.locale"
				:class="activeTab === 'team' ? 'sidebar_active' : 'sidebar_nonactive'"
				@click.native="activeTab = 'team'"
				data-qa="teamButton">
				<div>
					<font-awesome-icon
						:title="$t('team')"
						class="icon"
						icon="users"/>
						<span>{{ $t('team') }}</span>
				</div>
			</router-link>
			<router-link
				:to="'/' + 'units/' + $i18n.locale"
				:class="activeTab === 'units' ? 'sidebar_active' : 'sidebar_nonactive'"
				@click.native="activeTab = 'units'"
				data-qa="unitsButton">
				<div>
					<font-awesome-icon
						:title="$tc('unit', 3)"
						class="icon"
						icon="map-marked-alt"/>
					<span>{{ $tc('unit', 3) }}</span>
				</div>
			</router-link>
			<!-- <router-link :to="'/' + 'suppliers/' + $i18n.locale"><font-awesome-icon :title="$tc('supplier', 2)" class="icon" icon="truck" /><span>{{ $tc('supplier', 2) }}</span></router-link> -->
			<router-link
				:to="'/' + 'products/' + $i18n.locale"
				:class="activeTab === 'products' ? 'sidebar_active' : 'sidebar_nonactive'"
				@click.native="activeTab = 'products'"
				data-qa="catalogueButton">
				<div>
					<font-awesome-icon
						:title="$t('prodCatalogue')"
						class="icon"
						icon="tag"/>
					<span>{{ $t('prodCatalogue') }}</span>
				</div>
			</router-link>
			<router-link
				:to="'/' + 'dashboard/inventory/' + $i18n.locale"
				:class="activeTab === 'inventory' ? 'sidebar_active' : 'sidebar_nonactive'"
				@click.native="activeTab = 'inventory'"
				data-qa="inventoryButton">
				<div>
					<font-awesome-icon
						:title="$t('inventory')"
						class="icon"
						icon="dolly"/>
					<span>{{ $t('inventory') }}</span>
				</div>
			</router-link>
			<router-link
				:to="'/' + 'dashboard/payments/' + $i18n.locale"
				:class="activeTab === 'payments' ? 'sidebar_active' : 'sidebar_nonactive'"
				@click.native="activeTab = 'payments'"
				data-qa="paymentsButton">
				<div>
					<font-awesome-icon
						:title="$tc('payment', 3)"
						class="icon"
						icon="credit-card"/>
					<span>{{ $tc('payment', 3) }}</span>
				</div>
			</router-link>
			<router-link
				:to="'/' + 'dashboard/deliveries/' + $i18n.locale"
				:class="activeTab === 'deliveries' ? 'sidebar_active' : 'sidebar_nonactive'"
				@click.native="activeTab = 'deliveries'"
				data-qa="deliveryButton">
				<div>
				<font-awesome-icon
					:title="$tc('delivery', 2)"
					class="icon"
					icon="box-open"
				/><span>{{ $tc('delivery', 2) }}</span>
				</div></router-link>
			<!-- <router-link
				:to="'/' + 'tax/verification/' + $i18n.locale"
				:class="activeTab === 'tax' ? 'sidebar_active' : 'sidebar_nonactive'"
				@click.native="activeTab = 'tax'"
				data-qa="taxVerificationButton">
				<div>
					<font-awesome-icon
						:title="$tc('taxVerification', 3)"
						class="icon2"
						icon="receipt"/>
					<span style="margin-left: 20px;">{{ $tc('taxVerification', 3) }}</span>
				</div>
			</router-link> -->
			<router-link
				:to="'/' + 'dashboard/marketplace/' + $i18n.locale"
				:class="activeTab === 'marketplace' ? 'sidebar_active' : 'sidebar_nonactive'"
				@click.native="activeTab = 'marketplace'"
				data-qa="marketplaceButton">
				<div>
					<font-awesome-icon
						:title="$t('marketplace')"
						class="icon"
						icon="store"/>
					<span>{{ $t('marketplace') }}</span>
				</div>
			</router-link>
		</div>
		<!--sidebar end-->

		<div class="content">
			<b-modal id="credit-card-modal" size="lg" hide-footer>
				<template v-slot:modal-title>
					<!-- {{ $t('changePlan') }} -->
				</template>
					<CreditCardForm></CreditCardForm>
				</b-modal>
			<div class="card">
				<router-view @updateProfile="updateProfile" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import ClientService from '@/services/ClientService.js'
// import SubscriptionTable from '@/components/ui/SubscriptionTable.vue';
import CreditCardForm from '@/components/forms/CreditCardForm.vue'
import ProfileDropdown from '@/components/common/ProfileDropdown.vue'
import NotificationBell from '@/components/common/NotificationBell.vue'
import axios from 'axios'

export default {
  components: {
    // SubscriptionTable,
	CreditCardForm,
    ProfileDropdown,
    NotificationBell,
  },
  data() {
    return {
      isActive: false,
      imageUrl: null,
      // subscriptionDetails: {},
      // daysRemaining: 1, // trial days
      // isSubscriptionDone: false,
      baseUrl: process.env.VUE_APP_API_URL,
      notifications: null,
      activeTab: 'dashboard',
      tabList: [
        'dashboard',
        'profile',
        'team',
        'units',
        'products',
        'inventory',
        'payments',
        'deliveries',
      ],
    }
  },
  computed: mapState(['client']),
  methods: {
	topFunction() {
	document.body.scrollTop = 0; // For Safari
	document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	},
    logout() {
      this.$store.dispatch('logout')
    },
    updateProfile(e) {
      this.imageUrl = e
    },
    fetchClientDetails() {
      ClientService.getClientDetails()
        .then((response) => {
          this.imageUrl =
            response.data && response.data.length > 0
              ? response.data[0].img_path
              : null
        })
        .catch((error) => {
          const notification = {
            type: 'error',
            message:
              'There was a problem fetching client details: ' + error.message,
          }
          this.$store.dispatch('notification/add', notification, { root: true })
        })
    },
    async fetchNotificationDetails() {
      await axios
        .get(`${process.env.VUE_APP_API_URL}/notification?lang=${this.$i18n.locale}`)
        .then((response) => {
          this.notifications = response.data
        })
    },
    // calculateRemainingDay() {
    //   const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    //   if(this.subscriptionDetails) {
    //     const freeTrialStartDate = new Date(this.subscriptionDetails['free_trial_start_date']);
    //     const todayDate = new Date();

    //     this.daysRemaining = (1 - Math.round(Math.abs((todayDate - freeTrialStartDate) / oneDay))); // Here 1 is trial days
    //   }
    // },
    // async closeModal() {
    //   this.$bvModal.hide("subscription-modal");
    //   this.isSubscriptionDone = true;
    //   this.subscriptionDetails = await this.$store.dispatch('fetchSubscriptionDetails')
    // }
  },
  async mounted() {
    (function(w,d,u){
            var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/60000|0);
            var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);
    })(window,document,'https://bitrix.linking-map.com/upload/crm/site_button/loader_2_iekwl6.js')

    // this.subscriptionDetails = await this.$store.dispatch('fetchSubscriptionDetails')
    // this.subscriptionDetails.status === 'active' ? this.isSubscriptionDone = true : this.calculateRemainingDay();
    const location = window.location.href
    const activePage = location.split('/')
    this.activeTab = activePage[activePage.length - 2]
    this.fetchClientDetails()
    this.fetchNotificationDetails()
  },
}
</script>

<style lang="css" scoped>
body {
  margin: 0;
  padding: 0;
}

header {
  z-index: 3;
  position: fixed;
  background: var(--bg-light);
  padding: 20px;
  width: calc(100% - 0%);
  top: 0;
  height: 75px;
}
.card {
  height: auto;
}

.left_area h3 {
  font-family: "Nasalization", Helvetica, Arial;  
  color: var(--white);
  margin: -30px;
  font-size: 35px;
  letter-spacing: 4px;
}

.logout_btn {
  padding: 5px;
  background: var(--bg-superLight);
  text-decoration: none;
  float: right;
  margin-top: -30px;
  margin-right: 30px;
  border-radius: 2px;
  font-size: 15px;
  font-weight: 100;
  color: var(--white);
  transition: 0.5s;
  transition-property: background;
}

.logout_btn:hover {
  background: rgb(73, 83, 94);
}

.trial_btn {
  padding: 5px;
  background: var(--primaryDark);
  text-decoration: none;
  float: right;
  margin-top: -30px;
  margin-right: 30px;
  border-radius: 2px;
  font-size: 15px;
  font-weight: 100;
  color: var(--white);
  transition: 0.5s;
  transition-property: background;
}

.trial_btn:hover {
  background: #49535e;
}

.sidebar {
  z-index: 1;
  top: 0;
  background: var(--bg-superLight);
  margin-top: 70px;
  padding-top: 30px;
  position: fixed;
  left: 0;
  width: 250px;
  height: 100%;
  transition: 0.5s;
  transition-property: left;
  overflow-y: auto;
}

.sidebar_active {
  background: var(--bg-light);
  color: var(--primaryDark) !important;
}

.sidebar_nonactive {
  background: var(--bg-superLight);
  color: var(--bg-superLight);
}

.profile_info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.sidebar .profile_info .profile_image {
  width: 200px;
  height: 80px;
  margin: auto;
  /* border-radius: 100px; */
  /* margin-bottom: 10px;
  margin-left: -50px; */
}

.sidebar .profile_info h4 {
  color: var(--white);
  margin-top: 0;
  margin-bottom: 50px;
  font-size: 1.2rem;
}

.sidebar a {
  color: var(--white);
  text-align: left;
  text-transform: uppercase;
  display: block;
  width: 100%;
  line-height: 45px;
  text-decoration: none;
  /* padding-left: 20px; */
  box-sizing: border-box;
  transition: 0.5s;
  transition-property: background;
}
.sidebar span {
  margin-left: 10px;
  font-size: 0.9em;
}
.sidebar a:hover {
  background: var(--bg-light);
}

.sidebar .no-hover:hover {
  background: var(--bg-superLight);
}

.sidebar .icon {
	font-size: 1.9em;
	margin-left: 40px;
	margin-bottom: -5px;
}
.sidebar_nonactive .icon {
	margin-left: 40px;
}

.sidebar .icon2 {
	font-size: 1.9em;
	margin-left: 45px;
	margin-bottom: -5px;
}
.sidebar_nonactive .icon2 {
	margin-left: 45px;
}

label #sidebar_btn {
  z-index: 1;
  color: var(--white);
  position: fixed;
  cursor: pointer;
  left: 20px;
  font-size: 30px;
  margin: 5px 0;
  transition: 0.5s;
  transition-property: color;
}

label #sidebar_btn:hover {
  background: var(--bg-light);
}

#check:checked ~ .sidebar {
  left: -185px;
}

#check:checked ~ .sidebar a span {
  display: none;
}

#check:checked ~ .sidebar a {
  font-size: 10px;
  margin-left: 165px;
  width: 100%;
}


.content {
  width: (100% - 250px);
  margin-top: 60px;
  padding: 20px;
  margin-left: 250px;
  /* background: url('../assets/static/images/bg.jpg'); */
  background-repeat: repeat-y repeat-x;
  background-position: center;
  background-size: cover;
  height: auto;
  min-height: 100vh !important;
  transition: 0.5s;
  z-index: -1;
}

#check:checked ~ .content {
  margin-left: 60px;
}

#check:checked ~ .sidebar .profile_info {
  display: none;
}

#check {
  display: none;
}

.mobile_nav {
  display: none;
}

.left_area h3 {
  font-weight: 600;
  color: var(--white);
}
.left_area span {
  font-weight: 100;
  color: var(--primaryDark);
}

/* Responsive CSS */

@media screen and (max-width: 780px) {
  header {
    padding: 0;
  }
  .sidebar {
    display: none;
  }

  #sidebar_btn {
    display: none;
  }

  .content {
    margin-left: 0;
    /* height: 100vh; */
    margin-top: 140px;
    padding: 10px 10px;
    transition: 0s;
  }

  #check:checked ~ .content {
    margin-left: 0;
  }

  .mobile_nav {
    display: block;
    width: calc(100% - 0%);
	position: fixed;
    z-index: 2;
	margin-top: 70px;
  }

  .nav_bar {
    background: var(--bg-light);
    width: (100% - 0px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
  }

  .nav_bar .mobile_profile_image {
    width: 100px;
    height: 40px;
    /* border-radius: 50%; */
  }

  .nav_bar .nav_btn {
    color: var(--white);
    font-size: 22px;
    cursor: pointer;
    transition: 0.5s;
    transition-property: color;
  }

  .nav_bar .nav_btn:hover {
    background: var(--bg-light);
  }

  .mobile_nav_items {
    background: var(--bg-superLight) !important;
    display: none;
  }

  .mobile_nav_items a {
    color: var(--white);
    display: block;
    text-align: left;
    letter-spacing: 1px;
    line-height: 50px;
    font-size: 0.8em;
    text-transform: uppercase;
    text-decoration: none;
    box-sizing: border-box;
    transition: 0.5s;
    padding-left: 40px;
    transition-property: background;
  }
  .mobile_nav_items a:hover {
    background: var(--bg-light);
  }
  .mobile_nav_items .icon {
    padding-right: 10px;
    font-size: 1.4em;
  }
  .mobile_nav_items span {
    padding-left: 10px;
    font-size: 1.2em;
  }
  .logout_btn {
    margin-right: 0px;
  }
  .active {
    display: block;
  }
  .left_area h3 {
  margin: 0px;
}
}
@media screen and (max-width: 500px) {
  .left_area h3 {
    text-align: center;
    font-size: 30px;
    /* padding-top: 25px; */
  }
  .logout_btn {
    font-size: 11px;
    margin-right: 8px;
  }
  .trial_btn {
    font-size: 7px;
    margin-top: -28px;
    margin-right: 68px;
  }
  .content {
	width: 100%;
    height: auto;
    background: none;
  }
  .card {
  height: 100%;
}
}

/* @media screen and (max-width: 400px) and (orientation: portrait) {
  .left_area h3 {
    font-size: 25px;
    text-align: center;
  }
}

@media screen and (max-width: 325px) and (orientation: portrait) {
  .left_area h3 {
    font-size: 25px;
    text-align: center;
  }
}

  @media screen and (max-width: 325px) and (orientation: landscape) {
  .left_area h3 {
margin-top: 1px 
}
} */
</style>